import { useCallback } from "react";

import { clsx } from "clsx";
import { useSelector } from "react-redux";

import { selectConferenceSnapshotSelf } from "Services/state/conferences/ConferenceSnapshotSelectors";

import { logger } from "../CallBar.utils";
import { useNetworkQualityStatus } from "../hooks";
import { CallBarLine } from "./CallBarLine";
import { CallTaskInfo } from "./CallTaskInfo";
import { UnstableNetworkBanner } from "./UnstableNetworkBanner/UnstableNetworkBanner";

import styles from "../CallBar.module.scss";

export type CallBarLayoutProps = React.PropsWithChildren<{
    hideElementsOnSmallScreen?: boolean;
}>;

const useCallBarLayoutData = () => {
    const { callSid: agentCallSid, taskSid, callerUri } = useSelector(selectConferenceSnapshotSelf) || {};
    const connectionParams = {
        CallSid: agentCallSid,
        To: callerUri,
        taskSid,
    };

    return {
        connectionParams,
        deviceCallSid: agentCallSid,
    };
};

export const CallBarLayout = ({ children, hideElementsOnSmallScreen = false }: CallBarLayoutProps): JSX.Element => {
    const { showBanner } = useNetworkQualityStatus();
    const { connectionParams, deviceCallSid } = useCallBarLayoutData();
    const onInfoUnavailable = useCallback(() => {
        logger.warn("ActivePanel: Task Info could not be rendered", {
            taskSid: connectionParams.taskSid,
            deviceCallSid,
            connectionParams,
        });
    }, [connectionParams, deviceCallSid]);
    const hideElementRules = {
        [styles.hideOnSmallScreen]: hideElementsOnSmallScreen,
    };

    return (
        <>
            {showBanner && <UnstableNetworkBanner />}
            <div className={styles.container} data-testid="callbar">
                <div className={clsx(styles.containerFragment, styles.textContent, hideElementRules)}>
                    <CallTaskInfo onInfoUnavailable={onInfoUnavailable} />
                </div>
                <div
                    className={clsx(styles.containerFragment, styles.buttonsContainer, {
                        [styles.buttonsContainerSmallScreen]: hideElementsOnSmallScreen,
                    })}
                >
                    {children}
                </div>
                <div className={clsx(styles.containerFragment, styles.textContent, hideElementRules, styles.right)}>
                    <CallBarLine />
                </div>
            </div>
        </>
    );
};
